import { Register } from "components/__subComponents/Register";
import React from "react";
import { Styles } from "./Styled";

const RegisterPage = () => {
  return (<Styles>
    <Register />
  </Styles>)
}

export default RegisterPage;
